import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8b69fc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "experience-slider vue-slider",
  "data-slot": "slider"
}
const _hoisted_2 = { "data-slot": "slider-track" }
const _hoisted_3 = ["aria-valuenow", "aria-valuetext"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "control",
      class: "vue-slider-control",
      onPointerdown: _cache[1] || (_cache[1] = (...args) => ($options.start && $options.start(...args))),
      onPointermove: _cache[2] || (_cache[2] = (...args) => ($options.move && $options.move(...args))),
      onPointerup: _cache[3] || (_cache[3] = (...args) => ($options.finish && $options.finish(...args))),
      onPointercancel: _cache[4] || (_cache[4] = (...args) => ($options.cancel && $options.cancel(...args))),
      onLostpointercapture: _cache[5] || (_cache[5] = (...args) => ($options.cancel && $options.cancel(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          "data-slot": "slider-range",
          style: _normalizeStyle({width: `${$props.value}%`})
        }, null, 4 /* STYLE */)
      ]),
      _createElementVNode("div", {
        ref: "thumb",
        role: "slider",
        tabindex: "0",
        "aria-label": "Therapist experience",
        "aria-orientation": "horizontal",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": $props.value,
        "aria-valuetext": $props.valueText,
        "data-slot": "slider-thumb",
        style: _normalizeStyle($options.thumbStyle),
        onKeydown: _cache[0] || (_cache[0] = (...args) => ($options.keydown && $options.keydown(...args)))
      }, null, 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_3)
    ], 544 /* NEED_HYDRATION, NEED_PATCH */)
  ]))
}